var exports = {
  "X": "GroupedHeading__25VpIR",
};

module.exports = exports;
